import { useFlags } from "launchdarkly-react-client-sdk";
import {
  type AgentNudgeMetadata,
  useAgentControlContext,
} from "src/components/explore/context/agent-control-context";

export const useFilterInsightsNudge = ():
  | ((prompt: string, metadata?: AgentNudgeMetadata) => void)
  | undefined => {
  const { appAudienceAgentsFilterInsights } = useFlags();
  const { agentAvailable, nudgeAgent } = useAgentControlContext();
  if (!appAudienceAgentsFilterInsights || !agentAvailable) {
    return undefined;
  }
  return nudgeAgent;
};
